import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
// import{sse_url} from '@/utils/baseUrl';

//数采点列表
export async function dcslist(params) {
    return post(erpserver+'/equipment/list', params, true)
}
export async function dcssave(params) {
    return post(erpserver+'/equipment/save', params, true)
}
export async function dcscancel(params) {
    return post(erpserver+'/equipment/cancel', params, true)
}
export async function list(params) {
    return post(erpserver+'/dcsInfo/list', params, true)
}
export async function save(params) {
    return post(erpserver+'/dcsInfo/save', params, true)
}
export async function dcsdelete(params){
    return post(erpserver+'/dcsInfo/delete', params, true)
}